import React, { useState,useEffect } from "react";
import { Button, Grid, Hidden, InputLabel, makeStyles} from "@material-ui/core";
import {
    CustomCheckbox,
    InputField,
} from "../FormFields";
import { ImagePreview } from "../../../Popup/ImagePreview";
import { useSelector } from "react-redux";
import DropZoneWithPreview from "../FormFields/DropZoneWithPreview";
import { MdOutlinePreview } from "react-icons/md";
import CustomColorPicker from "../FormFields/CustomColorPicker";
import { CustomTimeZone } from "../FormFields/CustomTimeZone";
import { useCCmodeSettingContext } from "../../../../../context/ccmodeSettingContext";

const useStyles = makeStyles((theme) => ({
    textField: {
        '& .MuiOutlinedInput-root':{
            borderRadius: "4px !important"
        },
        '& .MuiInputBase-input.Mui-disabled':{
            borderRadius: "4px",
            height: "0px"
        }
    },
    previewBtn: {
        height: "40px",
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    checkBoxContrainer: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up('xs')]: {
            alignItems: "center",
        }
    }
}))

export default function ThemeFrom(props) {
    const classes = useStyles();
    const {
        formField: {
            white_label_logo,
            wl_primarycolor,
            n_fontcolor,
            lab_primary,
            lab_fontcolor,
            theme,
            displayName,
            background_image,
            nav_bar_color,
            background_color,
            nav_bar_font
        },
        values,
        setCompanyLogo,
        setFieldValue,
        setBackGroundImage
    } = props;

    const { features } = useSelector((state) => state.plan)

    const theme_data = [
        {
            value: "theme1",
            label: "Theme 1",
        },
        {
            value: "theme2",
            label: "Theme 2",
        },
        {
            value: "theme3",
            label: "Theme 3",
        },
    ];

    const [preview,showPreview] = useState(false)

    const HandlePreview = () => {
        if(values.theme && values.theme.length){
            showPreview(true)
        }
    }
    
    return (
        <React.Fragment>
            <ImagePreview show={preview} image={values.theme} onClose={() => showPreview(false)} responseOnOk={() => showPreview(false)}/>
            <Grid container spacing={3}  >
                <Grid item xs={12} className="mt-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                {props.language.CCMODE_SETUP_THEME_SET_UPLOAD_LOGO}
                                <span className="small d-block mt-2 line-height-lg">Add your brand’s logo to personalize the CC Mode experience.</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <DropZoneWithPreview
                                filefield={white_label_logo.name}
                                setFieldValue={setFieldValue}
                                setFile={setCompanyLogo}
                                values={values}
                                uploadBtnText="upload logo"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start" justify="space-between">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                {props.language?.CCMODE_SETUP_THEME_SET_DISPLAY_NAME}
                                <span className="small d-block mt-2 line-height-lg">Enter the name you'd like displayed across CC Mode.</span>
                            </InputLabel>
                        </Grid>                                      
                        <Grid item xs={12} md={2}>
                            <InputField
                                className={classes.textField}
                                fullWidth
                                disabled = {features["company_name"].allowed === 0}
                                name={displayName.name}
                                value={values.displayName}
                                InputProps={{
                                    style: {
                                    height: '40px'
                                    },
                                }}
                            />   
                        </Grid>          
                    </Grid>
                </Grid>
                <hr className="w-100" />
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Theme Selection *
                                <span className="small d-block mt-2 line-height-lg">Choose a visual theme to match your brand’s identity.</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <div className={`${classes.checkBoxContrainer}`}>
                                <CustomCheckbox
                                    name={theme.name}
                                    label={theme.label}
                                    data={theme_data}
                                    classes={theme.classes}
                                    setFieldValue={setFieldValue}
                                    values={values}     
                                    selectallfields={props.selectallfields}
                                />  
                                <Button className={classes.previewBtn} variant="outlined" onClick={() => HandlePreview()} disabled={values.theme && !values.theme.length}><MdOutlinePreview className="mr-3" size={18} />Preview</Button>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <hr className="w-100" />
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Customize Theme Colors
                                <span className="small d-block mt-2 line-height-lg">Set primary and secondary colors for the interface.</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Grid container spacing={3} alignItems="center">
                                <Grid item xs={12} md={3} className="text-capitalize font-weight-bold">natural</Grid>
                                <Hidden mdDown>
                                    <Grid item xs={0} md={3}></Grid>
                                </Hidden>
                                <Grid item xs={6} md={3}> 
                                    <CustomColorPicker  
                                        name={wl_primarycolor.name}
                                        label={props.language.CCMODE_SETUP_THEME_SET_NATURAL}
                                        value={values.wl_primarycolor} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}> 
                                    <CustomColorPicker  
                                        name={n_fontcolor.name}
                                        label={props.language.CCMODE_SETUP_THEME_SET_NATURAL_FONT}
                                        value={values.n_fontcolor} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} alignItems="center" className="my-6">
                                <Grid item xs={12} md={3} className="text-capitalize font-weight-bold">lab grown</Grid>
                                <Hidden mdDown>
                                    <Grid item xs={0} md={3}></Grid>
                                </Hidden>
                                <Grid item xs={6} md={3}> 
                                    <CustomColorPicker  
                                        name={lab_primary.name}
                                        label={props.language.CCMODE_SETUP_THEME_SET_LAB}
                                        value={values.lab_primary} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}> 
                                    <CustomColorPicker  
                                        name={lab_fontcolor.name}
                                        label={props.language.CCMODE_SETUP_THEME_SET_LAB_FONT}
                                        value={values.lab_fontcolor} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} alignItems="center">
                                <Grid item xs={12} md={3} className="text-capitalize font-weight-bold">theme color</Grid>
                                <Grid item xs={6} md={3}>
                                    <CustomColorPicker  
                                        name={nav_bar_color.name}
                                        label={nav_bar_color.label}
                                        value={values.nav_bar_color} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}> 
                                    <CustomColorPicker  
                                        name={nav_bar_font.name}
                                        label={nav_bar_font.label}
                                        value={values.nav_bar_font} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}> 
                                    <CustomColorPicker  
                                        name={background_color.name}
                                        label={background_color.label}
                                        value={values.background_color} 
                                        setFieldValue={setFieldValue}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <hr className="w-100" />
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                {props.language.CCMODE_SETUP_THEME_SET_BACKGROUNDIMG}
                                <span className="small d-block mt-2 line-height-lg">Upload a background image for your CC Mode dashboard.</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <DropZoneWithPreview
                                filefield={background_image.name}
                                setFieldValue={setFieldValue}
                                setFile={setBackGroundImage}
                                values={values}
                                uploadBtnText="upload background"
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <hr className="w-100" />
                <Grid item xs={12} className="my-6">
                    <Grid container spacing={3} alignItems="flex-start" justify="space-between">
                        <Grid item xs={12} md={4}>
                            <InputLabel className="font-size-h6 font-weight-bold text-capitalize">
                                Time Zone *
                                <span className="small d-block mt-2 line-height-lg">Select your preferred time zone for accurate order and activity tracking.</span>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <CustomTimeZone ccmodesetting={props.ccmodesetting} setFieldValue={props.setFieldValue} />
                        </Grid>
                    </Grid>
                </Grid>              
            </Grid>
        </React.Fragment>
    );
}
